import { Box } from "@mui/material";
import OrderList from "./OrderList";

export default function ViewMyOrder(){
    return(
        <Box>
            <OrderList/>
        </Box>
    )
}